module.exports = __webpack_public_path__ + "img/9.1.4f056c26.png";